import { PropsWithChildren, ReactElement } from "react";
import { Anchor } from "client/Components";
import styles from "./InstanceOperatorLayout.module.less";

export const InstanceOperatorLayout = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.root}>
			<ul className={styles.menu}>
				<li>
					<Anchor href="/admin">
						Back to index
					</Anchor>
				</li>

				<li>
					<Anchor href="/admin/SignOut">
						Sign out
					</Anchor>
				</li>
			</ul>

			<div className={styles.content}>
				{children}
			</div>
		</div>
	);
};
InstanceOperatorLayout.displayName = "InstanceOperatorLayout";
